// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ki-models {
    gap: 8px;
}

.ki-model-row {
    align-items: center;
    gap: 8px;
}

.ki-model-name {
    flex: 1 1 200px;
    min-width: 200px;
}

.ki-model-context {
    flex: 0 0 120px;
    min-width: 100px;
}

.ki-capabilities {
    flex: 2 1 auto;
    flex-wrap: wrap;
    gap: 8px 16px;
    align-items: center;
}

.ki-model-picker {
    font-size: 12px;
    min-width: 180px;
    max-width: 240px;
}

.ki-mcp {
    gap: 8px;
}

.ki-mcp-row {
    align-items: center;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/ki/ki.settings.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":[".ki-models {\n    gap: 8px;\n}\n\n.ki-model-row {\n    align-items: center;\n    gap: 8px;\n}\n\n.ki-model-name {\n    flex: 1 1 200px;\n    min-width: 200px;\n}\n\n.ki-model-context {\n    flex: 0 0 120px;\n    min-width: 100px;\n}\n\n.ki-capabilities {\n    flex: 2 1 auto;\n    flex-wrap: wrap;\n    gap: 8px 16px;\n    align-items: center;\n}\n\n.ki-model-picker {\n    font-size: 12px;\n    min-width: 180px;\n    max-width: 240px;\n}\n\n.ki-mcp {\n    gap: 8px;\n}\n\n.ki-mcp-row {\n    align-items: center;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
